import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";

const codeVariants = {
    initial: { rotate: -90, scale: 0.5, opacity: 0 },
    animate: { rotate: 0, scale: 1, opacity: 1 },
    exit: { rotate: 90, scale: 0.5, opacity: 0 },
};

function LanguageToggle({ className = "" }) {
    const { i18n, t } = useTranslation();
    const isSpanish = i18n.language?.startsWith("es");

    const handleToggle = () => {
        i18n.changeLanguage(isSpanish ? "en" : "es");
    };

    return (
        <motion.button
            type="button"
            onClick={handleToggle}
            className={`theme-toggle lang-toggle ${className}`}
            aria-label={isSpanish ? t("lang.switchToEnglish") : t("lang.switchToSpanish")}
            title={isSpanish ? t("lang.switchToEnglish") : t("lang.switchToSpanish")}
            whileTap={{ scale: 0.85 }}
        >
            <AnimatePresence mode="wait" initial={false}>
                <motion.span
                    key={i18n.language}
                    variants={codeVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    transition={{ duration: 0.25, ease: "easeOut" }}
                    style={{
                        display: "inline-flex",
                        fontSize: "0.7rem",
                        fontWeight: 700,
                        letterSpacing: "0.02em",
                    }}
                >
                    {isSpanish ? t("lang.codeEnglish") : t("lang.codeSpanish")}
                </motion.span>
            </AnimatePresence>
        </motion.button>
    );
}

export default LanguageToggle;
